import OrganizationServiceTimePerService from "../../../components/organization/reports/daily/OrganizationServiceTimePerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyOrganizationServiceTimePerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    reportTypeId={REPORT_TYPE_IDS.daily_organization_service_time_per_service}
    title="Service Time Per Service"
    helmetTitle="Daily Organization Service Time Per Service"
    descriptionKey="ServiceTimePerService"
    columnDefinitions={SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="completed"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <OrganizationServiceTimePerService
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationServiceTimePerService;
